interface HSTToolProps {

}

export default function HSTTool(props: HSTToolProps) {
  return (
    <div className='
      bg-white
      border

      shadow-2xl

      sm:m-4
      sm:rounded

      p-4
    '>
      <p>Hi</p>
    </div>
  );
}